import { Col, Container, Row } from "react-bootstrap";

import zurich from "../../../assets/brands/wopclients_zurichsantander.png";
import philip_morris from "../../../assets/brands/wopclients_phillipmorris.png";
import techint from "../../../assets/brands/wopclients_techint.png";
import satoshi from "../../../assets/brands/wopclients_satoshitango.png";
import mcb from "../../../assets/brands/wopclients_mcb.png";
import roca from "../../../assets/brands/wopclients_rocaport.png";
import aerolineas from "../../../assets/brands/wopclients_aerolineasargentinas.png";
import aeropuertos from "../../../assets/brands/wopclients_aeropuertosargentina.png";
import amadeus from "../../../assets/brands/wopclients_amadeus.png";
import axion from "../../../assets/brands/wopclients_axion.png";
import trenes from "../../../assets/brands/wopclients_trenesargentinos.png";
import banelco from "../../../assets/brands/wopclients_banelco.png";
import bdo from "../../../assets/brands/wopclients_bdo.png";
import hausler from "../../../assets/brands/wopclients_hausler.png";
import benomad from "../../../assets/brands/wopclients_benomad.png";
import bodega from "../../../assets/brands/wopclients_bodegasfindelmundo.png";
import assist_med from "../../../assets/brands/wopclients_assist-med.png";
import flip from "../../../assets/brands/wopclients_flip.png";
import nxtp from "../../../assets/brands/wopclients_nxtp.png";
import afi from "../../../assets/brands/wopclients_afi.png";
import * as ReactTranslated from "react-translated";

const brands = [
  { pos: 1, img: zurich },
  { pos: 2, img: philip_morris },
  { pos: 3, img: techint },
  { pos: 4, img: satoshi },
  { pos: 5, img: mcb },
  { pos: 6, img: roca },
  { pos: 7, img: aerolineas },
  { pos: 8, img: aeropuertos },
  { pos: 9, img: amadeus },
  { pos: 10, img: axion },
  { pos: 11, img: trenes },
  { pos: 12, img: banelco },
  { pos: 13, img: bdo },
  { pos: 14, img: hausler },
  { pos: 15, img: benomad },
  { pos: 16, img: bodega },
  { pos: 17, img: assist_med },
  { pos: 18, img: flip },
  { pos: 19, img: nxtp },
  { pos: 20, img: afi },
];

const Brands = () => {
  return (
    <Container fluid className="container_brands pt-5 pb-5">
      <Container>
        <Row>
          <Col>
            <h2 className="pt-5 pb-5">
              {" "}
              <ReactTranslated.Translate text="titleBrandTrust" />
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xxl={8} xl={9} lg={9} md={10} xs={12} className="mx-auto text-center">
            <Row>
              {brands
                .sort((a, b) => b.pos < a.pos)
                .map((b) => (
                  <Col md={3} xs={6} className="mx-auto text-center">
                    <img src={b.img} className="img-fluid logo-brand" />
                  </Col>
                ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Brands;
